import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Grid,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import AddBoxIcon from "@material-ui/icons/AddBox";
import HeaderImage from "../../assets/img/preguntasFrecuentes.svg";
import HeaderEmergencia from "../../assets/img/emergencia_1.svg";
import HeaderEmergenciaCircle from "../../assets/img/help-circle.svg";
import { useStateAuthValue } from "../../context/Auth/AuthState";
import { Role } from "../../models/enums";
import withStyles from "@material-ui/core/styles/withStyles";

const IconLeftAccordionSummary = withStyles({
  expandIcon: {
    order: -1,
  },
})(AccordionSummary);

const Help = () => {
  const [{ userData }] = useStateAuthValue();
  const currentRole = userData?.active_role;
  const isPatient = currentRole === Role.PATIENT;
  const isProfessional = currentRole === Role.PROFESSIONAL;
  const allowed = [
    "Infecciones respiratorias altas como estados gripales, sinusitis, refrío",
    "Tos, catarro, dolor de garganta, disfonía",
    "Lesiones en piel, erupciones, urticaria",
    "Náuseas, vómitos, diarrea, constipación, dolor abdominal leves",
    "Cefalea, migraña",
    "Infecciones tracto urinario, molestias para orinar",
    "Ansiedad, insomnio",
    "Síntomas ginecológicas",
    "Dolores articulares, dolores de espalda",
    "Patología pediátrica de baja complejidad",
    "Picadura de insectos",
    "Conjuntivitis",
    "Traumatismo leves",
    "Control de patologías crónicas estables",
    "Quemaduras menores",
  ];
  const notAllowed = [
    "Dolor de pecho",
    "Señal de infarto o ataque cardíaco",
    "Signos de accidente cerebro vascular como aparición repentina de falta de movilidad o adormecimientos de miembros, dificultad para hablar",
    "Perdida abrupta de la conciencia, sincope",
    "Convulsiones",
    "Sangrados, hemorragias",
    "Dificultad para respirar",
    "Intoxicación, sobredosis de medicamentos",
    "Fracturas",
    "Erupciones cutáneas severas",
    "Dolor abdominal intenso y continuo",
    "Quemaduras moderadas a severas",
    "Fracturas o traumatismos moderados a graves",
    "Traumatismo de cerebro con pérdida de conocimiento",
    "Traumatismo ocular u ojo rojo doloroso",
    "Intento de suicidio (autoeliminación)",
    "Brote psicótico",
  ];
  const [expanded, setExpanded] = useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className="help">
      <div className="header-professional">
        <img className="image" src={HeaderEmergenciaCircle} alt="Ayuda" />
        <h2>Ayuda</h2>
      </div>
      <div className="container">
        <div>
          <div className="contact-wrapper">
            <div className="contact">
              <div className="center-attention">
                <img className="image" src={HeaderEmergencia} alt="Ayuda" />
                <h2>Atención al cliente</h2>
              </div>
              <p>
                Ante cualquier duda podés comunicarte con nosotros al email
                <strong>
                  {" "}
                  <a href="mailto:contacto@mediline.com.ar">
                    contacto@mediline.com.ar
                  </a>
                  <a
                    style={{
                      color: "#0002C6F",
                      textDecoration: "none",
                    }}
                    href="tel:+5492615636701"
                  >
                    {" "}
                    o al 549 261 563-6701{" "}
                  </a>
                </strong>
              </p>
            </div>
          </div>
          {currentRole === "PROFESSIONAL" && (
            <div className="contact-wrapper" style={{ marginTop: "20px" }}>
              <div className="contact">
                <div className="center-attention">
                  <img className="image" src={HeaderEmergencia} alt="Ayuda" />
                  <h2>Asistencia Técnica</h2>
                </div>
                <p>
                  Si necesitás asistencia técnica enviá el mensaje
                  &quot;Asistencia técnica&quot; al
                </p>
                <a
                  style={{
                    display: "block",
                    color: "#000",
                    fontSize: "1.6em",
                    textDecoration: "none",
                  }}
                  href="tel:+5492615636701"
                >
                  549 261 563-6701
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Help;
